// 공통 사이트 하단 — 사회적협동조합 내비두 블록 · 긴급 상담 · 다크 푸터 (HomePage 에서 분리, 2026-10-06 · R06-04)
import { Link } from 'react-router-dom';
import logoIconUrl from '@shared/assets/brand/logo_icon.png';
import s from './SiteBottom.module.scss';

export const HOMEPAGE_URL = 'https://www.navido.kr';
export const INSTAGRAM_URL = 'https://www.instagram.com/navido_2019';
const BLOG_URL = 'https://blog.naver.com/navido2019';

export function SiteBottom() {
  return (
    <>
      <section id="report" className={s.navidoIntro}>
        <div className={s.navidoIn}>
          <span className={s.introIcon}><i className="fas fa-seedling" aria-hidden="true" /></span>
          <h3 id="title-site-bottom">사회적협동조합 내비두</h3>
          <p className={s.introDesc}>
            내비두는 고립·은둔을 겪은 사람들이 함께 만드는 자립 공동체입니다.<br />
            나를 찾아가는 길을 함께합니다.<br />
            <span className={s.introQuote}>내비두와 당신은 서로의 이음고리입니다.</span>
          </p>
          <div className={s.snsRow}>
            <a id="link-home-homepage" href={HOMEPAGE_URL} target="_blank" rel="noopener noreferrer" className={s.snsBtn}>
              <i className={`fas fa-globe ${s.snsBrand}`} aria-hidden="true" /> 홈페이지
            </a>
            <a id="link-site-bottom-sns-btn" href={BLOG_URL} target="_blank" rel="noopener noreferrer" className={s.snsBtn}>
              <i className={`fa-brands fa-blogger ${s.snsGreen}`} aria-hidden="true" /> 공식 블로그
            </a>
            <a id="link-home-instagram" href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className={s.snsBtn}>
              <i className={`fa-brands fa-instagram ${s.snsPink}`} aria-hidden="true" /> 인스타그램
            </a>
          </div>
        </div>
      </section>

      <section className={s.crisis} aria-label="긴급 상담 안내">
        <div className={s.crisisIn}>
          <span className={s.crisisIcon}><i className="fas fa-phone-volume" aria-hidden="true" /></span>
          <div>
            <h4>긴급 상담 및 도움 요청</h4>
            <p>
              본인 또는 타인의 생명이 위급한 상황일 경우에는 24시간 상담 가능한 정신건강 위기상담전화
              {' '}<strong>1577-0199</strong> 혹은 보건복지콜센터{' '}<strong>129</strong>에 도움을 요청하십시오.
              긴급 신고는 <strong>119</strong> 안전신고센터를 이용하시기 바랍니다.
            </p>
          </div>
        </div>
      </section>

      <footer className={s.ftr}>
        <div className={s.ftrIn}>
          <div className={s.ftrGrid}>
            <div className={s.ftrOrg}>
              <div className={s.ftrLogo}>
                <img src={logoIconUrl} alt="" className={s.ftrLogoN} />
                <h5>사회적협동조합 내비두</h5>
              </div>
              <p><strong>이사장 :</strong> 유현주</p>
              <p><strong>주소 :</strong> (11695) 경기도 의정부시 태평로 89번길 36 4층</p>
              <p><strong>전화 :</strong> <a id="link-site-bottom-tel" href="tel:03182181117">031-821-8117</a></p>
              <p><strong>이메일 :</strong> <a id="link-site-bottom-mailto" href="mailto:navido2019@gmail.com">navido2019@gmail.com</a></p>
            </div>
            <div>
              <h5>사업자 정보</h5>
              <ul>
                <li><strong>사업자등록번호 :</strong> 713-82-00698</li>
                <li><strong>통신판매업신고번호 :</strong> 제 000호</li>
                <li><strong>개인정보책임자 :</strong> 유현주</li>
              </ul>
            </div>
            <div>
              <h5>이용 정책</h5>
              <ul>
                <li><Link to="/terms">이용약관</Link></li>
                <li><Link to="/privacy" className={s.ftrStrong}>개인정보처리방침</Link></li>
                <li><Link to="/health-consent">건강 민감정보 수집·이용</Link></li>
                <li><a id="link-site-bottom-location" href="#" aria-disabled="true">위치기반 서비스 이용약관</a></li>
              </ul>
            </div>
          </div>
          <div className={s.ftrBottom}>
            <p>© 2019 - 2026 Navido. All rights reserved.</p>
            <div className={s.ftrSns}>
              <a href={HOMEPAGE_URL} target="_blank" rel="noopener noreferrer" aria-label="홈페이지"><i className="fas fa-home" /></a>
              <a href={BLOG_URL} target="_blank" rel="noopener noreferrer" aria-label="네이버 블로그"><i className="fa-brands fa-blogger" /></a>
              <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" aria-label="인스타그램"><i className="fa-brands fa-instagram" /></a>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
